import Vue from "vue";
import VueRouter from "vue-router";
import AppConst from "@utils/app-const";

Vue.use(VueRouter);

const routes = [
  {
    path: AppConst.APPURL.INDEX,
    name: AppConst.ROUTENM.INDEX,
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/Index.vue"),
    meta: {
      title: "お客様情報の入力",
    },
  },
  {
    path: AppConst.APPURL.SERVICE_MENU + "/:token?",
    name: AppConst.ROUTENM.SERVICE_MENU,
    component: () =>
      import(/* webpackChunkName: "serviceMenu" */ "../views/ServiceMenu.vue"),
    meta: {
      title: "有料サービスのお申込み選択",
    },
  },
  {
    path: AppConst.APPURL.CONFIRM + "/:token?",
    name: AppConst.ROUTENM.CONFIRM,
    component: () =>
      import(/* webpackChunkName: "confirm" */ "../views/Confirm.vue"),
    meta: {
      title: "お申込み内容の確認",
    },
  },
  {
    path: AppConst.APPURL.ANSHIN_INFO + "/:token?",
    name: AppConst.ROUTENM.ANSHIN_INFO,
    component: () =>
      import(/* webpackChunkName: "anshinInfo" */ "../views/AnshinInfo.vue"),
    meta: {
      title: "安心だもんプランご加入のご案内",
    },
  },
  {
    path: AppConst.APPURL.DISCOUNT_INFO + "/:token?",
    name: AppConst.ROUTENM.DISCOUNT_INFO,
    component: () =>
      import(/* webpackChunkName: "discount" */ "../views/DiscountInfo.vue"),
    meta: {
      title: "有料プラン兄弟割のご案内",
    },
  },
  {
    path: AppConst.APPURL.DISCOUNT_APPLY + "/:token?",
    name: AppConst.ROUTENM.DISCOUNT_APPLY,
    component: () =>
      import(/* webpackChunkName: "discount" */ "../views/DiscountApply.vue"),
    meta: {
      title: "ご兄弟情報の入力",
    },
  },
  {
    path: AppConst.APPURL.ZERO_COMPLETE,
    name: AppConst.ROUTENM.ZERO_COMPLETE,
    component: () =>
      import(/* webpackChunkName: "complete" */ "../views/Complete0.vue"),
    meta: {
      title: "お申込み手続き完了",
    },
  },
  {
    path: AppConst.APPURL.SECRET + "/:key?",
    name: AppConst.ROUTENM.SECRET,
    component: () =>
      import(/* webpackChunkName: "mainte" */ "../views/Secret.vue"),
    meta: {
      title: "メンテ中テスト",
    },
  },
  {
    path: AppConst.APPURL.OUTOFPERIODS,
    name: AppConst.ROUTENM.OUTOFPERIODS,
    component: () =>
      import(/* webpackChunkName: "mainte" */ "../views/OutOfPeriods.vue"),
    meta: {
      title: "お申込み期間外",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
